import { metricKeys } from '@pulse/metrics';

/* eslint-disable import/prefer-default-export */
export const SUMMARY_METRICS = {
  EI: [
    metricKeys.Attempts,
    metricKeys.Plays,
    metricKeys.PlaysPercentage,
    metricKeys.ConcurrentPlays,
    metricKeys.EndedPlays,
    metricKeys.UniqueDevices,
    metricKeys.UniqueDevicesWithAttempts,
    metricKeys.Minutes,
    metricKeys.MinutesPerUniqueDevice,
    metricKeys.MinutesPerEndedPlay,
    metricKeys.PercentageComplete,
  ],
  AI: [
    metricKeys.Plays,
    metricKeys.AdTotalMinutes,
    metricKeys.AdCompletedCreativePlays,
    metricKeys.ConcurrentPlays,
    metricKeys.Attempts,
    metricKeys.PlaysPercentage,
    metricKeys.AdsNotStartedPct,
    metricKeys.AdSlateDurationPct,
    metricKeys.RebufferingRatio,
    metricKeys.EndedPlaysPerUniqueDevice,
  ],
  APP: [
    metricKeys.AppTotalUserEvents,
    metricKeys.AppTotalEvents,
    metricKeys.AppSubscribers,
    metricKeys.AppUniqueDevices,
    metricKeys.AppPageLoads,
    metricKeys.AppAvgPageLoadTime,
    metricKeys.AverageMinutesPerPage,
    metricKeys.AppScreenLoads,
    metricKeys.AppAvgScreenLoadTime,
    metricKeys.AppCrashSessions,
  ],
  ODP: [],
  ECO_SERVER: [],
};
